import { getCssClasses } from '../utils';
import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbColumnLine } from '../../types/pbBlocks';

export type ColumnLineType = ContentTypeObject & PbColumnLine;

/**
 * Aggregates the configuration of a column line element.
 * @param node
 */
export function columnLineConfigAggregator(node: CustomHtmlElement): ColumnLineType {
    return {
        ...getCssClasses(node),
        uniqueID: node.attributes['data-pb-style'],
    };
}
